app
    .controller('manifestBaggingDeliveryViewCtrl', function ($rootScope, $scope,_API_URL, $state, $window, shareData,modalFactory,modalService, $filter, urlServices, _VAR_GLOBAL,toaster,$location) {
        $scope.filter = '';
        $scope.dataList = {
            totalItems: 0,
            summary:{},
            data: []
        };
        $scope.paginationOptions = {
            pageNumber: 1,
            pageSize: _VAR_GLOBAL.limit,
            sort: null
        };
        $scope.perTglP = {
            startDate: moment().subtract(7, 'days'),
            endDate: moment()
        };
        $scope.confirmFinish=function(dt){
            $scope.dataSelesai=dt;
            modalService.showModal({}, {
                closeButtonText: 'Tidak',
                actionButtonText: 'Ya',
                headerText: 'Konfirmasi Selesai',
                bodyText: 'Selesaikan Surat Jalan : ' +  dt.sj_id
            })
            .then(function (result) {
                if (result) {
                    urlServices.updateData('api/bagging-sj/'+$scope.dataSelesai.sj_id+'/confirm', {}, function (g, s) {
                        if(g){
                            toaster.pop('error','Error',g);
                        }else{
                            toaster.pop('success','Sukses', 'Surat Jalan dikonfirmasi');
                            $scope.viewData(1);
                        }
                    })
                }
            });
        };
        $scope.viewData = function (pg,qry) {
            $scope.paginationOptions.pageNumber = pg;
            $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter,qry);
        };
        $scope.detail=function(n){
            if (!n || !n.sj_id) {
                return toaster.pop('warning', 'Surat Jalan', 'Nomor Surat Jalan tidak ditemukan');
            }
            return modalFactory.open('lg', 'modal.surat.jalan.detail.html', 'modalSuratJalanDetailCtrl', {
                sjId: n.sj_id
            });
        };
       
        $scope.getData = function (pageSize, page, searchText, qry) {
            setTimeout(function () {
                var startDate = moment($scope.perTglP.startDate).format("YYYY-MM-DD");
                var endDate = moment($scope.perTglP.endDate).format("YYYY-MM-DD");
                var data = 'limit=' + pageSize + '&pg=' + page + '&startDate=' + startDate + '&endDate=' + endDate;
                if (searchText) {
                    data += '&term=' + searchText.toUpperCase();
                }
                urlServices.ambilData('api/bagging-sj?' + data, {}, function (err, sukses) {
                    if (err) {
                        toaster.pop('error', 'Error', err);
                        $scope.dataList.totalItems = 0;
                        $scope.dataList.data = []
                    } else {
                        $scope.dataList.totalItems = sukses.records;
                        $scope.dataList.data = sukses.data;
                    }
                })
            }, 100);
        };

        $scope.$watch('perTglP', function (newDate) {
            if (newDate) {
                $scope.viewData(1);
            }
        }, false);

        $scope.viewData(1);
    })
    .controller('manifestBaggingDeliveryEntryCtrl',function ($rootScope, $scope, $state, $location, $filter, urlServices, modalService, modalFactory, toaster, _VAR_GLOBAL) {
        $scope.deliveryData = [];
        $scope.data = {
            sj_date: moment().toDate(),
            total_collie: 0,
            actual_weight: 0,
            total_volumetric: 0
        };
        $scope.isEdit = false;
        $scope.undelData=[];
        $scope.selectedBaggings = {};

        // Date filter state - default to last 7 days (same as Surat Jalan View)
        $scope.filterDate = {
            startDate: moment().subtract(7, 'days').toDate(),
            endDate: moment().toDate()
        };

        // Date range picker options for manifest date filter
        $scope.filterDateOptions = {
            showDropdowns: true,
            locale: {
                format: 'DD/MM/YYYY'
            },
            eventHandlers: {
                'apply.daterangepicker': function(ev, picker) {
                    $scope.filterDate.startDate = picker.startDate.toDate();
                    $scope.filterDate.endDate = picker.endDate.toDate();
                    $scope.getBagingUndel(); // Auto-refresh on date change
                }
            }
        };

        $scope.dateOptions = {
            singleDatePicker: true,
            showDropdowns: true,
            locale: {
                format: 'DD/MM/YYYY'
            },
            eventHandlers: {
                'apply.daterangepicker': function(ev, picker) {
                    $scope.data.sj_date = picker.startDate.toDate();
                }
            }
        };

        $scope.showListVendor = function() {
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'baggingAgentList',
                params: {}
            });
        };

        $scope.$on('pilih-bagging-agent', function (event, args) {
            if (args && args.agent) {
                $scope.data.agent_name = args.agent.name;
            }
        });

        $scope.saveSJ=function(){
            var bagIds = Object.keys($scope.selectedBaggings).filter(function(k){ return $scope.selectedBaggings[k]; });
            if (bagIds.length === 0) {
                return toaster.pop('error', 'Validasi', 'Silakan pilih minimal satu Bagging');
            }
            if (!$scope.data.agent_name) {
                return toaster.pop('error', 'Validasi', 'Silakan isi nama Vendor (Agent)');
            }

            modalService.showModal({}, {
                closeButtonText: 'Tidak',
                actionButtonText: 'Ya',
                headerText: 'Simpan',
                bodyText: 'Simpan Surat Jalan Digital untuk ' + bagIds.length + ' Bagging?'
            })
            .then(function (result) {
                if (result) {
                    var payload = angular.copy($scope.data);
                    payload.bag_ids = bagIds;
                    urlServices.simpanData('api/bagging-sj', payload, function (g, s) {
                        if (g) {
                            toaster.pop('error', 'Error', g.err || g);
                        } else {
                            toaster.pop('success', 'Sukses', 'Surat Jalan Digital berhasil disimpan');
                            // Open print preview in new window
                            if (s && s.sj_id) {
                                var printUrl = '/manifest-baging-delivery-print?no=' + s.sj_id;
                                window.open(printUrl, '_blank');
                            }
                            $location.path('/manifest-baging-delivery-view');
                        }
                    });
                }
            });
        };

        $scope.getBagingUndel=function(){
            var startDate = $scope.filterDate.startDate;
            var endDate = $scope.filterDate.endDate;

            // Handle native date input (returns string 'YYYY-MM-DD') or moment/Date object
            if (typeof startDate === 'string' && startDate) {
                startDate = moment(startDate, 'YYYY-MM-DD').toDate();
            } else if (startDate instanceof Date) {
                startDate = moment(startDate).toDate();
            }
            if (typeof endDate === 'string' && endDate) {
                endDate = moment(endDate, 'YYYY-MM-DD').toDate();
            } else if (endDate instanceof Date) {
                endDate = moment(endDate).toDate();
            }

            var startStr = $filter('date')(startDate, 'yyyy-MM-dd');
            var endStr = $filter('date')(endDate, 'yyyy-MM-dd');
            var query = 'startDate=' + startStr + '&endDate=' + endStr;

            console.log('Fetching bagging with query:', query);

            urlServices.ambilData('api/bagging-sj/undelivered?' + query, {}, function (e, s) {
                console.log('Result:', s, 'Error:', e);
                if (e) {
                    $scope.undelData=[];
                } else {
                    $scope.undelData=s;
                }
            });
        };

        $scope.toggleSelection = function (dt) {
            $scope.selectedBaggings[dt.bag_id] = !$scope.selectedBaggings[dt.bag_id];
            $scope.updateSelection();
        };

        $scope.updateSelection = function () {
            var totalWeight = 0;
            var totalCollie = 0;
            var totalVolumetric = 0;
            var count = 0;

            angular.forEach($scope.undelData, function(n) {
                if ($scope.selectedBaggings[n.bag_id]) {
                    totalWeight += parseFloat(n.actual_weight || 0);
                    totalCollie += parseInt(n.total_collie || 0);
                    totalVolumetric += Math.ceil(parseFloat(n.measured_weight || n.volume_weight || 0));
                    count++;
                }
            });

            $scope.data.actual_weight = totalWeight;
            $scope.data.total_collie = totalCollie;
            $scope.data.total_volumetric = totalVolumetric;
        };

        $scope.getSelectedBaggingText = function() {
             var bagIds = Object.keys($scope.selectedBaggings).filter(function(k){ return $scope.selectedBaggings[k]; });
             if (bagIds.length === 0) return 'Belum ada yang dipilih';
             if (bagIds.length === 1) return bagIds[0];
             return bagIds.length + ' Bagging terpilih';
         };

         $scope.getBagingUndel();
    })
    .controller('manifestBaggingDeliveryPrintCtrl', function ($rootScope, _API_URL, $scope, $state, $location, $filter, urlServices, modalService, modalFactory, toaster, _VAR_GLOBAL) {
        var sjId = urlServices.getUrlParameter('no');
        $scope.dataGroup = {};

        urlServices.ambilData('api/bagging-sj/' + sjId, {}, function (e, d) {
            if (d) {
                // Pre-process data for layout with many koli (baggings)
                // Group detail by destination (tujuan)
                var destGroups = {};
                (d.detail || []).forEach(function (row) {
                    if (!destGroups[row.tujuan]) {
                        destGroups[row.tujuan] = {
                            tujuan: row.tujuan,
                            rows: [],
                            total_koli: 0,
                            total_weight: 0,
                            total_volumetric: 0,
                            bagging_list: row.bagging_list
                        };
                    }
                    destGroups[row.tujuan].rows.push(row);
                    // Accumulate totals from rows that have them (usually the first one from my backend logic)
                    destGroups[row.tujuan].total_koli += parseInt(row.total_koli || 0);
                    destGroups[row.tujuan].total_weight += parseFloat(row.total_weight || 0);
                    destGroups[row.tujuan].total_volumetric += parseFloat(row.total_volumetric || 0);
                });

                var processedDetail = [];
                angular.forEach(destGroups, function (group) {
                    group.rows.forEach(function (row, idx) {
                        row.is_first = (idx === 0);
                        row.row_span = group.rows.length;
                        row.total_koli = group.total_koli;
                        row.total_weight = group.total_weight;
                        row.total_volumetric = group.total_volumetric;
                        row.bagging_list = group.bagging_list;
                        processedDetail.push(row);
                    });
                });

                d.detail = processedDetail;
                $scope.dataGroup = d;
            } else {
                toaster.pop('error', 'Error', 'Data tidak ditemukan: ' + (e.err || e));
            }
        });
    });
